import styled from 'styled-components'

import { Panel, Text } from '@sketch/components'
import { ReactComponent as ExclamationMarkIcon } from '@sketch/icons/exclamation-mark-triangle-64'

export const StyledExclamationMarkIcon = styled(ExclamationMarkIcon)`
  margin: 0 auto;
  opacity: 0.55;
`

export const ErrorMessageContainer = styled.pre`
  max-height: 144px;
  overflow: auto;

  margin-top: 16px;
  padding: 16px;

  border-radius: 4px;
  background: ${({ theme }) => theme.colors.background.secondary.B};
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  line-height: 1.5;
  font-size: ${({ theme }) => theme.fontSizes.D};
  text-align: left;
`

export const StyledPanel = styled(Panel)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 448px;
  padding: 32px;

  text-align: center;
  background-color: ${({ theme }) => theme.colors.background.secondary.A};
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.panel};
  border-radius: ${({ theme }) => theme.radii.large};
`

export const Description = styled(Text)`
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  width: 100%;
`

export const PanelTitle = styled(Panel.Title)`
  margin: 8px 0 4px 0;
  padding: 0;
`

export const PanelBody = styled(Panel.Body)`
  &&&& {
    padding: 0;
  }
`

export const PanelFooter = styled(Panel.Footer)`
  margin-top: 16px;
  padding: 0;
`

export const BottomText = styled(Text)`
  margin: 24px auto 0;
  text-align: center;
`
